import { GlSkeletonLoader } from '@gitlab/ui';
export default {
    name: 'VueMergeRequestWidgetLoading',
    components: {
        GlSkeletonLoader
    }
};
